<template>
  <!-- XOL-67 (V5), UX spec 2.5 item 1: the read-only block of ONE option of an RTA, drawn on Step 4 ("Approved option", with Decline… in the slot) and
       reusable in Finalize ("Final option"). It draws the rows it is given and the View option button; what the rows say is the caller's (lib/rtaDecision
       approvedOptionRows, lib/rtaCompletion finalOptionRows). The default slot is where the caller's own acts go, beside View option.
       XOL-693: Finalize also draws the RTS it would link in this block (heading "RTS #2190", rtaCompletion.rtsCandidateRows, no optionId, its
       own View RTS button in the slot). -->
  <div class="rta-option-summary">
    <h5 :id="headingId">{{ heading }}</h5>

    <div class="bg-bordered" role="group" :aria-labelledby="headingId">
      <el-form :label-position="isMediumOrLess ? 'top' : 'left'" :label-width="labelWidth" class="rta-option-summary__form" @submit.native.prevent>
        <el-form-item v-for="row in rows" :key="row.label" :label="row.label">
          <b v-if="row.value">{{ row.value }}</b><b v-else class="text-muted">Not entered</b>
        </el-form-item>
      </el-form>

      <div v-if="optionId || $slots.default" class="rta-option-summary__acts">
        <el-button
          v-if="optionId"
          type="primary"
          size="mini"
          round
          icon="fa fa-chevron-right"
          class="rta-view-btn"
          :aria-label="viewLabel"
          @click="viewOption">View option</el-button>
        <slot />
      </div>
    </div>
  </div>
</template>


<script>
import { pushDrawer } from '@/lib/layerNav'

export default {
  name: 'RtaOptionSummary',

  props: {

    // The silver title: "Approved option" (Step 4), "Final option" (Finalize).
    heading: {
      type: String,
      default: 'Approved option'
    },

    // [{ label, value }]; a value of '' reads "Not entered".
    rows: {
      type: Array,
      default: function () { return [] }
    },

    // The option the View option button opens in its layer. None (not read yet): no button.
    optionId: {
      type: Number,
      default: null
    },

    // The option's number, for the button's name ("View option 2").
    optionNo: {
      type: Number,
      default: null
    },

    // The label column. 150px so that "Site width × depth" and "Status on handover" (UX spec 2.5) stay on one line.
    labelWidth: {
      type: String,
      default: '150px'
    }

  },

  computed: {
    headingId () {
      return 'rta-option-summary-' + this._uid
    },

    viewLabel () {
      return 'View option' + (this.optionNo ? ' ' + this.optionNo : '')
    }
  },

  methods: {
    // The option's layer, over the drawer. Its own gates keep it read-only where the RTA says so.
    viewOption () {
      if (this.optionId && this.$router) {
        pushDrawer(this.$router, { open: { candidate: { id: Number(this.optionId) } } })
      }
    }
  }
}
</script>


<style scoped>
  .rta-option-summary h5 { margin: 4px 0 14px; }
  .rta-option-summary .bg-bordered { padding: 8px 12px 10px; }
  .rta-option-summary__form >>> .el-form-item { margin-bottom: 0; }
  .rta-option-summary__form >>> .el-form-item__label,
  .rta-option-summary__form >>> .el-form-item__content { line-height: 30px; }
  .rta-option-summary__acts { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-top: 8px; }
  .rta-option-summary__acts >>> .el-button { margin: 0; }

/* Carlos 2026-10-29: room between the chevron and the text (Element spaces only its own el-icon-* icons, not FontAwesome ones). */
.rta-view-btn >>> .fa + span {
  margin-left: 6px;
}
</style>
